export type HistoryPeriod = "week" | "month" | "quarter" | "year" | "custom";

const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function monthName(i: number): string { return MONTH_NAMES[i]!; }

export function currentAnchor(period: HistoryPeriod): string {
  const now = new Date();
  const ist = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  if (period === "week") {
    const dow = ist.getDay() || 7;
    return new Date(Date.UTC(ist.getFullYear(), ist.getMonth(), ist.getDate() - (dow - 1))).toISOString().slice(0, 10);
  }
  if (period === "month") return new Date(Date.UTC(ist.getFullYear(), ist.getMonth(), 1)).toISOString().slice(0, 10);
  if (period === "year") return new Date(Date.UTC(ist.getFullYear(), 0, 1)).toISOString().slice(0, 10);
  const qStartMonth = Math.floor(ist.getMonth() / 3) * 3;
  return new Date(Date.UTC(ist.getFullYear(), qStartMonth, 1)).toISOString().slice(0, 10);
}

export function shiftAnchor(period: HistoryPeriod, anchor: string, delta: number): string {
  const d = new Date(anchor + "T00:00:00Z");
  if (period === "week") { d.setUTCDate(d.getUTCDate() + delta * 7); return d.toISOString().slice(0, 10); }
  if (period === "month") return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + delta, 1)).toISOString().slice(0, 10);
  if (period === "year") return new Date(Date.UTC(d.getUTCFullYear() + delta, 0, 1)).toISOString().slice(0, 10);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + delta * 3, 1)).toISOString().slice(0, 10);
}

export function rangeFor(period: "week" | "month" | "quarter" | "year", anchor: string): { from: string; to: string; label: string } {
  const d = new Date(anchor + "T00:00:00Z");
  if (period === "year") {
    const to = new Date(Date.UTC(d.getUTCFullYear(), 11, 31));
    return { from: anchor, to: to.toISOString().slice(0, 10), label: String(d.getUTCFullYear()) };
  }
  if (period === "week") {
    const end = new Date(d);
    end.setUTCDate(end.getUTCDate() + 6);
    const sameMonth = d.getUTCMonth() === end.getUTCMonth();
    const label = sameMonth
      ? `${monthName(d.getUTCMonth()).slice(0, 3)} ${d.getUTCDate()}-${end.getUTCDate()}, ${end.getUTCFullYear()}`
      : `${monthName(d.getUTCMonth()).slice(0, 3)} ${d.getUTCDate()} - ${monthName(end.getUTCMonth()).slice(0, 3)} ${end.getUTCDate()}, ${end.getUTCFullYear()}`;
    return { from: anchor, to: end.toISOString().slice(0, 10), label };
  }
  if (period === "month") {
    const to = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0));
    return { from: anchor, to: to.toISOString().slice(0, 10), label: `${monthName(d.getUTCMonth())} ${d.getUTCFullYear()}` };
  }
  const qStartMonth = d.getUTCMonth();
  const to = new Date(Date.UTC(d.getUTCFullYear(), qStartMonth + 3, 0));
  const q = qStartMonth / 3 + 1;
  return { from: anchor, to: to.toISOString().slice(0, 10), label: `Q${q} ${d.getUTCFullYear()} (${monthName(qStartMonth).slice(0, 3)}-${monthName(qStartMonth + 2).slice(0, 3)})` };
}

// Every calendar date in [from, to] inclusive, for filling in "Day Off" gaps
// where no AttendanceRecord exists.
export function eachDate(from: string, to: string): string[] {
  const out: string[] = [];
  const cur = new Date(from + "T00:00:00Z");
  const end = new Date(to + "T00:00:00Z");
  while (cur <= end) {
    out.push(cur.toISOString().slice(0, 10));
    cur.setUTCDate(cur.getUTCDate() + 1);
  }
  return out;
}
